import { graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";

const ImageParagraph = ({ content }) => {
  const alt = content.r.img.img.alt;
  const image = getImage(content.r.img.r.img.localFile);

  return <GatsbyImage image={image} alt={alt} />;
};

export const query = graphql`
  fragment ParagraphImage on paragraph__image {
    type: __typename
    r: relationships {
      img: field_image_ref {
        img: field_image {
          alt
        }
        r: relationships {
          img: field_image {
            localFile {
              childImageSharp {
                gatsbyImageData(aspectRatio: 1.2, layout: FULL_WIDTH)
              }
            }
          }
        }
      }
    }
  }
`;

export default ImageParagraph;
